import { PagedEntityList, PayrollListItem } from '@herbjoy/apex-api-models';
import templateUrl from './processed-payrolls.component.html';

export const ProcessedPayrollsComponent = {
    bindings: {
        page: "<",
        onDownloadSummary: "&",
        onDownloadImport: "&",
        onUnprocessPayroll: "&",
        changePage: "&onChangePage"
    },
    controller: class {
        page: PagedEntityList<PayrollListItem>;
        payrolls: PayrollListItem[];
        totalEntityCount: number;
        pageNumber: number;
        pageSize: number;
        constructor() {
        }

        $onInit() {
            this.updatePageData()
        }

        $onChanges(changesObj) {
            if (changesObj.page) {
                this.updatePageData()
            }
        }

        updatePageData() {
            this.payrolls = this.page.Entities
            this.totalEntityCount = this.page.TotalEntityCount
            this.pageNumber = this.page.PageIndex + 1
            this.pageSize = this.page.PageSize
        }
    },
    controllerAs: "vm",
    templateUrl
}
